module.exports = __webpack_public_path__ + "static/media/Meda - Orange_PR Pink.910d5b33.jpg";